import { updateRadioStatusModelSchema } from '@/shared/api'
import dayjs from 'dayjs'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import { z } from 'zod'

dayjs.extend(isSameOrBefore)

export const updateRadioStatusModelSchemaRefined =
  updateRadioStatusModelSchema.superRefine((data, ctx) => {
    if (data.radioScheduled) {
      const now = dayjs()
      const notificationMinutes = data.sendNotificationTimeInMinutes

      // Проверка наличия дат
      if (!data.startDate || !data.endDate) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message:
            'Даты начала и окончания обязательны для запланированного эфира',
          path: ['startDate'],
        })
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: ' ',
          path: ['endDate'],
        })
        return
      }

      const startDate = dayjs(data.startDate)
      const endDate = dayjs(data.endDate)

      // Проверка: дата начала не в прошлом
      if (startDate.isBefore(now)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Дата начала не может быть в прошлом',
          path: ['startDate'],
        })
        return
      }

      // Проверка: дата окончания не в прошлом
      if (endDate.isBefore(now)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Дата окончания не может быть в прошлом',
          path: ['endDate'],
        })
        return
      }

      // Проверка: дата начала должна быть минимум через время уведомления
      const minStartDate = now.add(notificationMinutes, 'minute')
      if (startDate.isBefore(minStartDate)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: `Дата начала должна быть минимум через ${notificationMinutes} минут (время отправки уведомления)`,
          path: ['startDate'],
        })
        return
      }

      // Проверка: дата окончания позже даты начала
      if (endDate.isSameOrBefore(startDate)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Дата окончания должна быть позже даты начала',
          path: ['endDate'],
        })
      }

      // Проверка: минимальная длительность эфира
      const minStreamDuration = 1
      if (endDate.diff(startDate, 'minute') < minStreamDuration) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: `Длительность эфира должна быть не менее ${minStreamDuration} минут`,
          path: ['endDate'],
        })
      }
    }
  })
